import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AdminLoginModal from "../components/AdminLoginModal";
import "./VerifyOtp.css";
import logo from "../assets/logo_sgoolfotografie.svg";

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showAdminModal, setShowAdminModal] = useState(false);
  const navigate = useNavigate();

  const { verifyOtp, login } = useAuth();

  const email = localStorage.getItem("otp_email");

  const handleVerify = async (e) => {
    e.preventDefault();

    setErrorMessage("");

    if (otp.length !== 6 || isNaN(otp)) {
      setErrorMessage("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      setLoading(true);
      const res = await verifyOtp(email, otp);

      if (res.success) {
        // Use admin-assigned roles from backend, fallback to Fotograaf
        const roles = Array.isArray(res.roles) && res.roles.length > 0 ? res.roles : ["Fotograaf"];

        const userData = {
          username: email,
          email: email,
          roles,
          organizationName: email.split("@")[1] || "Organization",
          loginTime: new Date().toISOString(),
        };

        login(userData);

        localStorage.setItem("verified_email", email);

        navigate("/dashboard");
      } else {
        setErrorMessage(res.error || "Verification failed. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Verification failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleAdminClick = () => {
    setShowAdminModal(true);
  };

  const handleCloseModal = () => {
    setShowAdminModal(false);
  };

  return (
    <div className="verify-page">
      <button onClick={handleAdminClick} className="admin-btn-top" title="Admin Login">
        👤 Admin
      </button>

      <AdminLoginModal isOpen={showAdminModal} onClose={handleCloseModal} />

      <div className="verify-container">
        <div className="verify-header">
          <img src={logo} alt="App Logo" className="logo-img" />
          <h1>Verifieer uw e-mailadres</h1>
          <p>Vul de 6-cijferige code in die u ontvangen heeft</p>
        </div>

        <div className="verify-form-container">
          <form onSubmit={handleVerify} className="verify-form">
            <div className="form-group">
              <label>E-mailadres</label>
              <input
                type="email"
                value={email || ""}
                readOnly
                className="read-only-input"
              />
            </div>

            <div className="form-group">
              <label>
                Vul 6-cijferige code in <span className="required">:</span>
              </label>
              <input
                type="text"
                maxLength={6}
                placeholder="Enter 6-digit OTP"
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value);
                  setErrorMessage("");
                }}
                required
                className={errorMessage ? "error-input" : ""}
              />
              {errorMessage && <p className="error-text">{errorMessage}</p>}
              <small>
                Controller de inbox of spam-folder op een 6-cijferige code van 
                <strong>render@sgoolfotografie.nl</strong>
              </small>
            </div>

            <button type="submit" className="btn" disabled={loading}>
              {loading ? "Verifying..." : "Verifeer code"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
